import { combineReducers } from "redux";
import PrimaryMarketIpoReducer from "./PrimaryMarketsIpoReducer";
export default combineReducers({
    PrimaryMarketIpoReducer,
});
